import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaShoppingCart, FaEnvelope } from 'react-icons/fa';

import AlertIcon from './alert-icon/alert-icon.component';

import Client from '../../../tools/client';
import { ensureSocketConnected, onSafe } from '../../../tools/socket';

import { UserContext } from '../../../contexts/user.context';

import {
  AlertContainer,
  HeaderNav
} from './header.styles';

const client = new Client();

const Header = () => {
  const navigate = useNavigate();
  const [newOrders, setNewOrders] = useState(0);
  const [newMessages, setNewMessages] = useState(0);

  const { currentUser } = useContext(UserContext);

  useEffect(() => {
    if (currentUser?.roleId < 4) {
      getOrders();
      getPendingMessages();

      ensureSocketConnected();

      const offNewMessage = onSafe('newMessage', getPendingMessages);
      const offNewOrder = onSafe('newOrder', getOrders);

      return () => {
        offNewMessage();
        offNewOrder();
      };
    }
  }, [currentUser]);

  const getOrders = async () => {
    const newOrders = await client.getOrdersByStatus('new');
    const pendingOrders = await client.getOrdersByStatus('pending');

    setNewOrders(newOrders.rows.length + pendingOrders.rows.length);
  };

  const getPendingMessages = async () => {
    const res = await client.getMessages({ status: 'pending', deleted: false });
    setNewMessages(res.length);
  };

  return (
    <HeaderNav>
      <AlertContainer>
        <AlertIcon
          count={newMessages}
          Icon={FaEnvelope}
          label="New Messages"
          onClick={() => navigate('/messages')}
        />
        <AlertIcon
          count={newOrders}
          Icon={FaShoppingCart}
          label="New Orders"
          onClick={() => navigate('/orders')}
        />
      </AlertContainer>
    </HeaderNav>
  );
};

export default Header;